import styled, { css } from 'styled-components';
import { StatusInformativeNotificationType } from '../ThemeProvider/types';

export const Container = styled.div<{
  status: StatusInformativeNotificationType;
  isMobile: boolean;
  width: number;
  clickable: boolean;
}>`
  border: 1px solid;
  border-radius: 10px;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  ${({ status, theme, isMobile }) => css`
    padding: ${isMobile ? 12 : 16}px;
    background: ${`${theme.informationNotification[status].background}`};
    border-color: ${`${theme.informationNotification[status].border}`};
  `};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'normal')};
`;

export const NotificationTitle = styled.div<{
  isMobile: boolean;
}>`
  column-gap: 8px;
  display: flex;
  font-family: 'Mulish', sans-serif;
  font-style: normal;
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 4px;

  & > div:nth-child(2) {
    align-items: center;
    display: flex;
    flex: 1;
    text-align: left;
  }

  ${({ isMobile }) => css`
    font-size: ${isMobile ? 12 : 16}px;
    line-height: ${isMobile ? 15 : 20}px;
  `}
`;

export const NotificationBody = styled.div<{
  isMobile: boolean;
}>`
  font-family: 'Mulish', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  padding-left: 28px;
  white-space: pre-line;
  ${({ isMobile }) => css`
    font-size: ${isMobile ? 12 : 14}px;
    line-height: ${isMobile ? 15 : 17}px;
  `}
`;

export const SimpleNotificationContainer = styled.div`
  column-gap: 8px;
  display: flex;
  font-style: normal;
  justify-content: space-between;
  & > div:nth-child(2) {
    flex: 1;
    padding-left: 0;
    text-align: left;
  }
`;
